import Vue from 'vue'
import axios from 'axios'

/* TODO: Remove with replace all module task */
export async function fetchTodayTasks({ commit }, userId) {
  await Vue.axios({
    url: '/child/' + userId + '/getTodayTasks/',
  }).then((response) => {
    commit('setTodayTasks', response.data)
  }).catch((error) => {
    commit('error', error.mesage)
  })
}

export async function fetchAllTasks({ commit }, { childId, query = {} }) {
  try {
    const { type = 0 } = query;
    commit('cleanErrors');
    const { data: allTasks } = await axios.get(
      `/child/${childId}/getAllTasks/`,
      { params: query }
    );

    commit('setAllTasks', allTasks)
  } catch (error) {
    console.log('[Tasks]', error);
    commit('error', error);
  }
}

export async function filterTaskPerDate(
  { commit },
  { childId, datesToFilter = ['today'] }
) {
  const promiseAll = await Promise.all(
    datesToFilter.map(async date => {
      const { data } = await axios.get(
        `/child/${childId}/getTasksDueDateFilter/?filter=${date}`
      );

      return { tasks: data, date };
    })
  );
  commit('setTaskPerDate', promiseAll);
}
export async function fetchPendingTasks({ commit }, userId) {
  await Vue.axios({
    url: '/child/' + userId + '/getAllPendingTasks/',
  }).then((response) => {
    commit('cleanErrors')
    commit('setPendingTaks', response.data)
  }).catch((error) => {
    commit('error', error.mesage)
  })
}

function objectToFormData(object={}) {
  const formData = new FormData();
  Object.entries(object).filter(([_, value]) => value).forEach(([key, value]) => formData.append(key, value));
  return formData;
}

export async function addNewTask({ commit }, {payload={}}) {
  const url = `/task/`;
  const isChild = !(Vue.$cookies.get('userType') == "parent")
  const formData = objectToFormData(payload);

  try {
    const response = await Vue.axios({url, data:formData, method: 'POST'})
    commit('cleanErrors')
    commit('setSelectedTaskData', response.data)
    return isChild
    ? {
      'coins': response.data.coins,
      'points': response.data.points,
      'description': response.data.description,
      'module': response.data.module,
      'correct': true
    }
    : {'correct': true}
  } catch (error) {
    return { 'error': error.response.data, 'correct': false }
  }
}

export async function editTask({commit}, {payload={}, config={}}) {
  const {isProject='', isEvent='', id=''} = config;
  const url =`/task/${id}/`;
  const data = objectToFormData(payload);
  try {
    const {data:task} = await Vue.axios({url, data, method: 'PUT'});
    commit('cleanErrors');
    commit('setSelectedTaskData', task);
    return {'correct': true}
  } catch (error) {
    console.error(error);
    return { 'error': error.response.data, 'correct': false }
  }
}

export async function UpdateTaskInformation({ commit }, payload) {

  let isChild = !(Vue.$cookies.get('userType') == "parent")
  let due_date = payload.taskDate + "T" + payload.taskHour
  let data = {
    title: payload.taskTitle,
    child: payload.taskChild,
    date: due_date,
    project: payload.taskProject,
    description: payload.taskDescription,
    isChild: isChild,
    subject: payload.taskClass,
    type: payload.taskType,
    priority: payload.taskPriority,
    attachment: payload.taskAttachment,
  }
  if (payload.taskRepeat) {
    if (payload.taskRepeatDate) {
      data['repeat'] = payload.taskRepeat
      data['repeat_date'] = payload.taskRepeatDate + "T12:00"
    }
  }
  if (payload.notification_date) {
    data['notification_date'] = payload.notification_date
  }
  commit('cleanErrors')
  await Vue.axios({
    method: 'PUT',
    url: '/task/' + payload.taskId + "/",
    data: data,

  }).then((response) => {
    //console.log(response)
    return true
  }).catch(function(error) {
    commit('error', error.response.data)
    return false
  })
}

export async function UpdateTask({ commit }, id) {
  commit('cleanErrors')
  let toReturn = ''
  await Vue.axios({
    method: 'POST',
    url: '/task/' + id + '/complete/',
    data: {
      value: true
    },

  }).then((response) => {
    toReturn = response.data
  }).catch(function(error) {
    commit('error', error)
    toReturn = false
  })
  //console.log(toReturn)
  return toReturn
}

export async function DeliveryTask({ commit }, id) {
  commit('cleanErrors')
  await Vue.axios({
    method: 'POST',
    url: '/task/' + id + '/delivery/',
    data: {
      value: true
    }
  }).then(() => {
    return true
  }).catch(function(error) {
    commit('error', error.response.data)
    return false
  })
}

export async function UpdateTasks({ commit }, ids) {
  commit('cleanErrors')
  await Vue.axios({
    method: 'POST',
    url: '/task/CompleteGroup/',
    data: {
      ids: ids
    }
  }).then((response) => {
    return response.data.points
  }).catch(function(error) {
    commit('error', error.response.data)
    return false
  })
}

export async function FetchRepeatOptions({ commit }) {
  await Vue.axios({
    method: 'GET',
    url: '/task_fields/GetRepeatOptions/'
  }).then((response) => {
    commit('setRepeatOptions', response.data)
  }).catch((error) => {
    commit('error', error.response.data)
  })
}

export async function FetchTypes({ commit }) {
  await Vue.axios({
    method: 'GET',
    url: '/task_fields/GetTypes/'
  }).then((response) => {
    commit('setTypes', response.data)
  }).catch((error) => {
    //console.log(error)
    commit('error', error.response.data)
  })
}

export async function FetchNotificationTypes({ commit }) {
  await Vue.axios({
    method: 'GET',
    url: '/task_fields/GetNotificationTypes/'
  }).then((response) => {
    commit('setNotificationTypes', response.data)
  }).catch((error) => {
    //console.log(error)
    commit('error', error.response.data)
  })
}

export async function deleteTask({ commit }, taskId) {
  try {
    await Vue.axios({method: 'DELETE', url: '/task/' + taskId + '/'});
  } catch (error) {
    console.error("[Task|Delete]", error);
    commit('error', error.response.data);
  }
}

export async function updateStatusToTask({commit},{task, status, isProject}) {
  const {id:taskId} = task;
  const {id:state} = status;
  try {
    const {data:coins} = await axios.put(`task/${taskId}/status/`, {state});
    return coins;
  } catch (error) {
    console.error('[Action Task]', error);
    commit('error', error.response.data)
  }
}

